export type MultiplierAnimationResult = {
  result: number
  possibleResults: number[]
}

export class MultiplierAnimation extends Phaser.GameObjects.Container {
  multiplierValue: number

  backgroundOverlay: Phaser.GameObjects.Graphics

  constructor(scene: Phaser.Scene, x: number, y: number, config: MultiplierAnimationResult) {
    super(scene, x, y)
    scene.add.existing(this)
    this.backgroundOverlay = this.createBackgroundOverlay()

    this.multiplierValue = config.result

    this.add([this.backgroundOverlay])
  }

  createBackgroundOverlay() {
    const { width, height } = this.scene.sys.game.canvas

    const overlay = this.scene.add.graphics()
    overlay.fillStyle(0x000000, 0.5)
    overlay.fillRect(-width / 2, -height / 2, width, height)

    return overlay
  }

  async play() {}
  skip() {
    this.cleanup()
    this.destroy()
  }

  cleanup() {}

  destroy(fromScene?: boolean): void {
    this.removeAll(true)
    super.destroy(fromScene)
  }
}
